// Функция ожидания
export const wait = ms => new Promise(r => setTimeout(r, ms));